import React from 'react';
import { Col, Row } from 'react-bootstrap';

function QuizzesInstruction() {
  return (
    <Row className="g-3 justify-content-between mb-4">
      <Col xs={12}>
        <h4>Introduction for Core Basics</h4>
        <p>
          The <strong>Core Basics</strong> checkpoint evaluates foundational
          technical knowledge through multiple-choice questions. This round
          tests essential skills in programming, algorithms, and
          problem-solving. Candidates are required to complete at least one{' '}
          <strong>Critical Tech</strong> to progress to the next stages of the
          recruitment process. Additional <strong>Supplementary Tech</strong>{' '}
          skills can also be demonstrated but are not mandatory.
        </p>
      </Col>
    </Row>
  );
}

export default QuizzesInstruction;
